import {routerReducer} from 'react-router-redux';
import {LOCATION_CHANGE} from 'react-router-redux';

const initialState = {
  pathname: '',
};

const reducer = (state, action) => {
  if (action.type === LOCATION_CHANGE) {
    return {
      ...routerReducer(state, action),
      pathname: action.payload.pathname,
      search: action.payload.search,
      query: action.payload.query,
    };
  }

  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/reducers/routing.js